// extracted by mini-css-extract-plugin
export default {"PrivacyPolicyPage":"TermsOfUse_PrivacyPolicyPage__DsYG9","ppcontainer":"TermsOfUse_ppcontainer__RGXyq"};